module.exports = __webpack_public_path__ + "static/media/30PerformancePhotos.16e3c5be.jpeg";